import { render, staticRenderFns } from "./talentSendPlayerList.vue?vue&type=template&id=169b5bde&scoped=true&"
import script from "./talentSendPlayerList.vue?vue&type=script&lang=js&"
export * from "./talentSendPlayerList.vue?vue&type=script&lang=js&"
import style0 from "./talentSendPlayerList.vue?vue&type=style&index=0&id=169b5bde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169b5bde",
  null
  
)

export default component.exports